/**
 * Time change modal (premium feature).
 *
 * Displays the shared UVChart component inside a modal overlay, allowing users
 * to click any data point to select that hour. Shares the same 12-hour windowed
 * data and navigation controls (Today/Now/Tomorrow, left/right scroll) as the
 * main page chart. Selecting a time immediately updates the app's UV reading.
 */
import React from 'react';
import UVChart from './UVChart';
import './TimeChangeModal.css';

const TimeChangeModal = ({
  isOpen,
  onClose,
  onTimeChange,
  onModeChange,
  isDark,
  uvForecast,
  graphMode,
  setGraphMode,
  graphOffset,
  setGraphOffset,
  navigationLimits,
  selectedTimestamp,
}) => {

  // Format the selected time for display
  const getSelectedLabel = () => {
    if (!selectedTimestamp) return '';
    const date = new Date(selectedTimestamp * 1000);
    return date.toLocaleString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      hour12: true,
    });
  };

  if (!isOpen) return null;

  return (
    <div className="time-modal-overlay" onClick={onClose}>
      <div
        className="time-modal"
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: isDark ? '#2a2a2a' : '#ffffff',
          color: isDark ? '#ffffff' : '#000000'
        }}
      >
        <div className="time-modal-header">
          <h2>Change time</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <div className="time-modal-body">
          <label>Click a point on the chart to select a time:</label>

          <UVChart
            chartData={uvForecast}
            graphMode={graphMode}
            setGraphMode={setGraphMode}
            graphOffset={graphOffset}
            setGraphOffset={setGraphOffset}
            navigationLimits={navigationLimits}
            onTimeSelect={(timestamp) => { onTimeChange(timestamp); onClose(); }}
            onModeChange={onModeChange}
            selectedTimestamp={selectedTimestamp}
            isDark={isDark}
          />

          {selectedTimestamp && (
            <div className="selected-time-label" style={{
              color: isDark ? '#aaa' : '#666'
            }}>
              Selected: <strong style={{ color: isDark ? '#fff' : '#000' }}>{getSelectedLabel()}</strong>
            </div>
          )}
        </div>

        <div className="time-modal-footer">
          <button
            className="close-modal-button"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default TimeChangeModal;
